import * as Yup from "yup";
import _ from "lodash";
import { getDateFromYearsToSubtract } from "../Utils/DateUtils";

Yup.setLocale({
  string: {
    min: "Must be ${min} characters or greater",
    max: "Must be ${max} characters or less",
    // required:"Required",
    matches: "Invalid format",
    email: "Invalid Email",
  },
  date: {
    max: "Date cannot be in the future",
  },
  number: {
    min: "Must be greater than or equal to ${min}",
    max: "Must be lesser than or equal to ${max}",
    integer: "Decimal values are not allowed",
  },
  mixed: {
    required: "Required",
  },
});

Yup.addMethod(Yup.object, "atLeastOneRequired", function (list, message) {
  return this.shape(
    list.reduce(
      (acc, field) => ({
        ...acc,
        [field]: this.fields[field].when(_.without(list, field), {
          is: (...values) => !values.some((item) => item),
          then: this.fields[field].required(message),
        }),
      }),
      {},
    ),
    list.reduce(
      (acc, item, idx, all) => [
        ...acc,
        ...all.slice(idx + 1).map((i) => [item, i]),
      ],
      [],
    ),
  );
});

const nameMaxLength = 100;
const AddressMaxLength = 60;
const PincodeMaxLength = 10;
const MobileNoMaxLength = 15;
const MobileNoMinLength = 5;
const CityMaxLength = 60;
const IfscMinLength = 11;
const IfscMaxLength = 11;
const pattern = /^[a-zA-Z0-9;*@+.()&: \/_-]+$/;
const addressPattern = /^[a-zA-Z0-9;,*@#+.()&: \/_-]+$/;
const pincodePattern = /^[0-9]+$/;
const mobilePattern = /^[0-9]+$/;
const ckycNoPattern = /^[0-9]+$/;
const panNoPattern = /^[a-zA-Z]{5}[0-9]{4}[A-Za-z]{1}$/;
const passportNoPattern = /^[a-zA-Z0-9;*@+.()&: \/_-]+$/; // this needs to be changed
/* const ifscPattern = /^[a-zA-Z]{4}[0]{1}[0-9]{6}$/; */
const bankAccountNoPattern = /^[0-9]+$/;
const bankNamepattern = /^[a-zA-Z. -]+$/;
const branchNamepattern = /^[a-zA-Z0-9;*@#+.()&: \/_-]+$/;
const accountTypePattern = /^[a-zA-Z ()-]+$/;
const countryPattern = /^[a-zA-Z .()&-]+$/;
const nationalityPattern = /^[a-zA-Z ()-]+$/;
const fullNameMaxLength = 250;
const pinMaxLength = 10;
const PanMaxLength = 10;
const udid = /^[a-zA-Z0-9 ]+$/;
const CKYCMaxLength = 14;
const emailMaxLength = 100;
const passportNoMaxLength = 60;
const stateCountryOfBirthMaxLength = 60;
const nationalityMaxLength = 60;
const taxResidencyDetailsMaxLength = 60;
const remarksMaxLength = 7000;
const bankDetailsMaxLength = 100;
const accountDetailsMaxLength = 50;
const addressLineThreeMaxLength = 255;

//pattern validation message
const patternMessage = "You can use A-Z,0-9,space,;,*,@,+,_,-,.,/,(,),&,:";
const udidpatternMessage = "You can use A-Z,0-9";

const pincodePatternMessage = "You can use 0-9";
const mobilePatternMessage = "You can use 0-9";
const ckycNoPatternMessage = "You can use 0-9";
const panNoPatternMessage =
  "PAN should have first 5 alphabets followed by 4 digits and 1 alphabet";
const passportNoPatternMessage =
  "You can use A-Z,0-9,space,;,*,@,+,_,-,.,/,(,),&,:"; // this needs to be changed
/* const ifscPatternMessage = "IFSC should have first 4 alphabets followed by 7 digits"; */
const bankAccountNoPatternMessage = "You can use 0-9";
const bankNamepatternMessage = "You can use A-Z,space,.,-";
const branchNamepatternMessage =
  "You can use A-Z,0-9,space,;,*,@,+,_,-,.,/,(,),&,#:";
const accountTypePatternMessage = "You can use A-Z,space,(,),-";
const countryPatternMessage = "You can use A-Z,space,-,.,(,),&";
const NationalityPatternMessage = "You can use A-Z,space,-,(,)";
const mobileMaxLengthMessage = "must be maximum of 15 numbers";
const mobileMinLengthMessage = "must be minimum of 5 numbers";

const branchPattern = /^[a-zA-Z0-9;*@+.,()&: \/_\-\s]+$/;
const branchPatternMessage =
  "You can use a-z, A-Z, 0-9, space, ., *, ,, ', (, ), &, :, ;, @, +, /, _, -";

/* Nominee Minor dob mindate */
function minorminDate() {
  return getDateFromYearsToSubtract(new Date(), 18);
}

export default [
  {
    widgetShortName: "PERSONALINFO",
    validationSchemaObj: Yup.object({
      personalInfoDTO: Yup.object().shape({
        keyPersonalInfoDTO: Yup.object().shape({
          title: Yup.object().nullable().required(" Required"),
          firstName: Yup.string()
            .nullable()
            .required("Required")
            .max(fullNameMaxLength)
            .matches(pattern, patternMessage),
          middleName: Yup.string()
            .nullable()
            .max(fullNameMaxLength)
            .matches(pattern, patternMessage),
          lastName: Yup.string()
            .nullable()
            .max(fullNameMaxLength)
            .matches(pattern, patternMessage),
          motherName: Yup.string()
            .nullable()
            .required("Required")
            .max(fullNameMaxLength)
            .matches(pattern, patternMessage),
          dateOfBirth: Yup.date()
            .nullable()
            .transform((curr, orig) => (orig === "" ? null : curr))
            .required("Required")
            .max(new Date(), "Date cannot be in the future"),
          permanentAddressLine1: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage)
            .when(["permanentAddressLine2", "permanentAddressLine3"], {
              is: (permanentAddressLine2, permanentAddressLine3) =>
                !permanentAddressLine2 && !permanentAddressLine3,
              then: Yup.string()
                .nullable()
                .required("Please fill any one of the address line"),
            }),
          permanentAddressLine2: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage),
          permanentAddressLine3: Yup.string()
            .nullable()
            .max(addressLineThreeMaxLength)
            .matches(addressPattern, patternMessage),
          permanentCity: Yup.string()
            .nullable()
            .required("Required")
            .max(AddressMaxLength)
            .matches(pattern, patternMessage),
          permanentState: Yup.object().nullable().required("Required"),
          permanentCountry: Yup.object().nullable().required("Required"),
          permanentPinCode: Yup.string()
            .nullable()
            .required("Required")
            .max(pinMaxLength)
            .matches(pincodePattern, pincodePatternMessage),
          isPermanentAddressSameAsCKYCAadhaar: Yup.string()
            .nullable()
            .required("Required"),
          addressProofType: Yup.object()
            .nullable()
            .when("isPermanentAddressSameAsCKYCAadhaar", {
              is: "No",
              then: Yup.object().nullable().required("Required"),
            }),
          addressProofImage: Yup.string().nullable(),
          addressProofFileName: Yup.string()
            .nullable()
            .when("isPermanentAddressSameAsCKYCAadhaar", {
              is: "No",
              then: Yup.string().nullable().required("Required"),
            }),
          addressProofPath: Yup.string().nullable(),
          modifiedPermanentAddressLine1: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage)
            .when(
              [
                "modifiedPermanentAddressLine2",
                "modifiedPermanentAddressLine3",
              ],
              {
                is: (
                  modifiedPermanentAddressLine2,
                  modifiedPermanentAddressLine3,
                ) =>
                  !modifiedPermanentAddressLine2 &&
                  !modifiedPermanentAddressLine3,
                then: Yup.string()
                  .nullable()
                  .required("Please fill any one of the address line"),
              },
            ),
          modifiedPermanentAddressLine2: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage),
          modifiedPermanentAddressLine3: Yup.string()
            .nullable()
            .max(addressLineThreeMaxLength)
            .matches(addressPattern, patternMessage),
          modifiedPermanentCity: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(pattern, patternMessage)
            .required("Required"),
          modifiedPermanentState: Yup.object().nullable().required("Required"),
          modifiedPermanentCountry: Yup.object()
            .nullable()
            .required("Required"),
          modifiedPermanentPinCode: Yup.string()
            .nullable()
            .max(pinMaxLength)
            .matches(pincodePattern, pincodePatternMessage)
            .required("Required"),
          residentialAddressSameAsPermanentAddress: Yup.string()
            .nullable()
            .required("Required"),
          residentialAddressLine1: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage)
            .when(["residentialAddressLine2", "residentialAddressLine3"], {
              is: (residentialAddressLine2, residentialAddressLine3) =>
                !residentialAddressLine2 && !residentialAddressLine3,
              then: Yup.string()
                .nullable()
                .required("Please fill any one of the address line"),
            }),
          residentialAddressLine2: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage),
          residentialAddressLine3: Yup.string()
            .nullable()
            .max(addressLineThreeMaxLength)
            .matches(addressPattern, patternMessage),
          residentialCity: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(pattern, patternMessage)
            .required("Required"),
          residentialState: Yup.object().nullable().required("Required"),
          residentialCountry: Yup.object().nullable().required("Required"),
          residentialPinCode: Yup.string()
            .nullable()
            .max(pinMaxLength)
            .matches(pincodePattern, pincodePatternMessage)
            .required("Required"),
          panNo: Yup.string()
            .nullable()
            .required("Required")
            .matches(panNoPattern, panNoPatternMessage)
            .max(PanMaxLength),
          gender: Yup.object().required("Required").nullable(),
          ckycNo: Yup.string()
            .nullable()
            .matches(ckycNoPattern, ckycNoPatternMessage)
            .max(CKYCMaxLength),
          email: Yup.string()
            .nullable()
            .email("Invalid email address")
            .max(emailMaxLength)
            .required("Required"),
          mobileNo: Yup.string()
            .nullable()
            .required("Required")
            .matches(mobilePattern, mobilePatternMessage)
            .max(MobileNoMaxLength, mobileMaxLengthMessage)
            .min(MobileNoMinLength, mobileMinLengthMessage),

          isDifferentlyAbled: Yup.string().nullable().required("Required"),
          impairmentTypeTagValue: Yup.object().nullable().shape({
            id: Yup.mixed().required(),
          }),
          impairmentPercentage: Yup.number()
            .nullable()

            .min(1)
            .max(100)
            .integer(),

          // udidNumber: Yup.string()
          //   .nullable()
          //   .matches(udid, udidpatternMessage)
          //   .length(18, "Should be 18 characters only")
          //   ,
          udidNumber: Yup.string()
            .nullable()
            .matches(udid, udidpatternMessage)
            .min(18, "Must be at least 18 characters")
            .max(20, "Should not exceed 20 characters"),
          impairmentProofFile: Yup.string().nullable(),
          impairmentProofFile: Yup.string().nullable(),

          impairmentProofFilePath: Yup.string().nullable(),
        }),
        additionalPersonalInfoDTO: Yup.object().shape({
          occupationType: Yup.object().nullable().required("Required"),
          educationalQualification: Yup.object()
            .nullable()
            .required("Required"),
          incomeLevel: Yup.object().nullable().required("Required"),
          politicallyExposed: Yup.string().nullable().required("Required"),
          natureOfPoliticalExposued: Yup.object()
            .nullable()
            .when("politicallyExposed", {
              is: "Yes",
              then: Yup.object().nullable().required("Required"),
            }),
          relatedPoliticallyExposed: Yup.string()
            .nullable()
            .required("Required"),
          relatedToPepNatureOfPoliticalExposued: Yup.object()
            .nullable()
            .when("relatedPoliticallyExposed", {
              is: "Yes",
              then: Yup.object().nullable().required("Required"),
            }),
          additionalPersonalInfoTcAccepted: Yup.boolean()
            .nullable()
            .required("Please accept the terms & conditions.")
            .oneOf([true], "Please accept the terms & conditions."),
        }),
        taxDeclarationDTO: Yup.object().shape({
          residentOfIndia: Yup.string().nullable().required("Required"),
          passportNo: Yup.string()
            .nullable()
            .max(passportNoMaxLength)
            .matches(passportNoPattern, passportNoPatternMessage)
            .when("residentOfIndia", {
              is: (residentOfIndia) => residentOfIndia != "Resident",
              then: Yup.string().nullable().required("Required"),
            }),
          nationality: Yup.string()
            .nullable()
            .required("Required")
            .max(nationalityMaxLength)
            .matches(nationalityPattern, NationalityPatternMessage),
          countryOfBirth: Yup.string()
            .nullable()
            .required("Required")
            .max(stateCountryOfBirthMaxLength)
            .matches(countryPattern, countryPatternMessage),
          stateOfBirth: Yup.string()
            .nullable()
            .matches(pattern, patternMessage)
            .max(stateCountryOfBirthMaxLength)
            .when("countryOfBirth", {
              is: (countryOfBirth) => {
                return (
                  !_.isEmpty(countryOfBirth) &&
                  countryOfBirth.toUpperCase() !== "INDIA"
                );
              },
              then: Yup.string().nullable().required("Required"),
            }),
          stateOfBirthObj: Yup.object()
            .nullable()
            .when("countryOfBirth", {
              is: (countryOfBirth) => {
                return (
                  !_.isEmpty(countryOfBirth) &&
                  countryOfBirth.toUpperCase() === "INDIA"
                );
              },
              then: Yup.object().nullable().required("Required"),
            }),
          taxDeclaration: Yup.string().nullable().required("Required"),
          indianPassportImage: Yup.string().nullable(),
          indianPassportFileName: Yup.string()
            .nullable()
            .when("residentOfIndia", {
              is: (residentOfIndia) => residentOfIndia != "Resident",
              then: Yup.string().nullable().required("Required"),
            }),
          indianPassportImagePath: Yup.string().nullable(),
          visaWorkPermitImage: Yup.string().nullable(),
          visaWorkPermitFileName: Yup.string()
            .nullable()
            .when("residentOfIndia", {
              is: (residentOfIndia) => residentOfIndia != "Resident",
              then: Yup.string().nullable().required("Required"),
            }),
          visaWorkPermitImagePath: Yup.string().nullable(),
          currentOverseasAddressProofImage: Yup.string().nullable(),
          currentOverseasAddressProofFileName: Yup.string()
            .nullable()
            .when("residentOfIndia", {
              is: (residentOfIndia) => residentOfIndia != "Resident",
              then: Yup.string().nullable().required("Required"),
            }),
          currentOverseasAddressProofImagePath: Yup.string().nullable(),
          chequeImage: Yup.string().nullable(),
          chequeFileName: Yup.string()
            .nullable()
            .when(["showChequeUpload"], {
              is: (showChequeUpload) => showChequeUpload === "true",
              then: Yup.string().nullable().required("Required"),
            }),
          chequeImagePath: Yup.string().nullable(),
          taxTcAccepted: Yup.boolean()
            .nullable()
            .required("Please accept the terms & conditions.")
            .oneOf([true], "Please accept the terms & conditions."),

          taxResidencyCountryDetails: Yup.array()
            .nullable()
            .of(
              Yup.object().shape({
                countryOfTaxResidency: Yup.object()
                  .nullable()
                  .required("Required"),
                taxIdentificationNumber: Yup.string()
                  .nullable()
                  .required("Required")
                  .matches(pattern, patternMessage)
                  .max(taxResidencyDetailsMaxLength),
                taxIdentificationType: Yup.string()
                  .nullable()
                  .required("Required")
                  .matches(pattern, patternMessage)
                  .max(taxResidencyDetailsMaxLength),
                remarks: Yup.string()
                  .nullable()
                  .required("Required")
                  .matches(pattern, patternMessage)
                  .max(remarksMaxLength),
              }),
            ),
        }),
        signatureUploadDTO: Yup.object().shape({
          signatureImage: Yup.string().nullable(),
          signatureFileName: Yup.string().nullable().required("Required"),
          signatureImagePath: Yup.string().nullable(),
        }),
      }),
    }),
  },
  {
    widgetShortName: "NOMINEE",
    validationSchemaObj: Yup.object({
      nomineeWidgetDTO: Yup.object().shape({
        nomineeCount: Yup.number().required("Required"),
        nominee1: Yup.object().shape({
          salutation: Yup.object().nullable().required("Required"),
          name: Yup.string()
            .nullable()
            .max(fullNameMaxLength)
            .required("Required")
            .matches(pattern, patternMessage),
          relationship: Yup.object().nullable().required("Required"),
          otherRelationshipRequired: Yup.boolean(),
          otherRelationship: Yup.string()
            .nullable()
            .max(nameMaxLength)
            .matches(pattern, patternMessage)
            .when("otherRelationshipRequired", {
              is: true,
              then: Yup.string().required("Required"),
            }),
          addressLine1: Yup.string()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage)
            .when(["addressLine2", "addressLine3"], {
              is: (addressLine2, addressLine3) =>
                !addressLine2 && !addressLine3,
              then: Yup.string()
                .nullable()
                .required("Please fill any one of the address line"),
            }),
          addressLine2: Yup.string()
            .nullable()
            .max(AddressMaxLength)
            .matches(addressPattern, patternMessage),
          addressLine3: Yup.string()
            .nullable()
            .max(addressLineThreeMaxLength)
            .matches(addressPattern, patternMessage),
          city: Yup.string()
            .nullable()
            .max(CityMaxLength)
            .required("Required")
            .matches(pattern, patternMessage),
          country: Yup.object().nullable().required("Required"),
          state: Yup.object().nullable().required("Required"),
          pincode: Yup.string()
            .nullable()
            .max(PincodeMaxLength)
            .required("Required")
            .matches(pincodePattern, pincodePatternMessage),
          mobileCountry: Yup.object()
            .nullable()
            .when("isMinor", {
              is: "No",
              then: Yup.object().nullable().required("Required"),
            }),
          mobileNo: Yup.string()
            .nullable()
            .max(MobileNoMaxLength, mobileMaxLengthMessage)
            .min(MobileNoMinLength, mobileMinLengthMessage)
            .when("isMinor", {
              is: "No",
              then: Yup.string().nullable().required("Required"),
            })
            .matches(mobilePattern, mobilePatternMessage),
          emailId: Yup.string()
            .nullable()
            .max(emailMaxLength)
            .email()
            .required("Required"),
          bankName: Yup.string()
            .nullable()
            .max(nameMaxLength)
            .matches(pattern, patternMessage),
          ifscCode: Yup.string()
            .nullable()
            .max(IfscMaxLength, "Must be equal to 11 characters")
            .min(IfscMinLength, "Must be equal to 11 characters"),
          branchName: Yup.string()
            .nullable()
            .max(nameMaxLength)
            .matches(branchPattern, branchPatternMessage),
          bankAccountNumber: Yup.string()
            .nullable()
            .max(nameMaxLength)
            .matches(bankAccountNoPattern, bankAccountNoPatternMessage),
          bankAccountType: Yup.object().nullable(),
          isMinor: Yup.string().nullable().required("Required"),
          sharePercentage: Yup.number()
            .nullable()
            .required("Required")
            .min(1)
            .max(100)
            .integer(),
          minorDOB: Yup.date()
            .nullable()
            .when("isMinor", {
              is: "Yes",
              then: Yup.date()
                .nullable()
                .required("Required")
                .min(minorminDate(), "Must be below 18"),
            })
            .max(
              new Date().toISOString().slice(0, 10),
              "Date cannot be in the future",
            )
            .transform((curr, orig) => (orig === "" ? null : curr)),
          residentialStatus: Yup.string().nullable(),
          guardianDTO: Yup.object()
            .nullable()
            .shape({
              isMinor: Yup.string().nullable(),
              name: Yup.string()
                .nullable()
                .max(nameMaxLength)
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.string().nullable().required("Required"),
                })
                .matches(pattern, patternMessage),
              addressLine1: Yup.string()
                .nullable()
                .max(AddressMaxLength)
                .when(["isMinor", "addressLine2", "addressLine3"], {
                  is: (isMinor, addressLine2, addressLine3) =>
                    isMinor === "Yes" && !addressLine2 && !addressLine3,
                  then: Yup.string()
                    .nullable()
                    .required("Please fill any one of the address line"),
                })
                .matches(addressPattern, patternMessage),
              addressLine2: Yup.string()
                .nullable()
                .max(AddressMaxLength)
                .matches(addressPattern, patternMessage),
              addressLine3: Yup.string()
                .nullable()
                .max(addressLineThreeMaxLength)
                .matches(addressPattern, patternMessage),
              city: Yup.string()
                .nullable()
                .max(CityMaxLength)
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.string().nullable().required("Required"),
                })
                .matches(pattern, patternMessage),
              country: Yup.object()
                .nullable()
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.object().nullable().required("Required"),
                }),
              state: Yup.object()
                .nullable()
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.object().nullable().required("Required"),
                }),
              pincode: Yup.string()
                .nullable()
                .max(PincodeMaxLength)
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.string().nullable().required("Required"),
                })
                .matches(pincodePattern, pincodePatternMessage),
              mobileCountry: Yup.object()
                .nullable()
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.object().required("Required").nullable(),
                }),
              mobileNo: Yup.string()
                .nullable()
                .max(MobileNoMaxLength, mobileMaxLengthMessage)
                .min(MobileNoMinLength, mobileMinLengthMessage)
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.string().nullable().required("Required"),
                })
                .matches(mobilePattern, mobilePatternMessage),
              emailId: Yup.string()
                .nullable()
                .email()
                .max(emailMaxLength)
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.string().nullable().required("Required"),
                }),
              relationship: Yup.object()
                .nullable()
                .when("isMinor", {
                  is: "Yes",
                  then: Yup.object().required("Required").nullable(),
                }),
              otherRelationshipRequired: Yup.boolean(),
              otherRelationship: Yup.string()
                .nullable()
                .max(nameMaxLength)
                .matches(pattern, patternMessage)
                .when("otherRelationshipRequired", {
                  is: true,
                  then: Yup.string().required("Required"),
                }),
              bankName: Yup.string()
                .nullable()
                .max(nameMaxLength)
                .matches(pattern, patternMessage),
              ifscCode: Yup.string()
                .nullable()
                .max(IfscMaxLength, "Must be equal to 11 characters")
                .min(IfscMinLength, "Must be equal to 11 characters"),
              branchName: Yup.string()
                .nullable()
                .max(nameMaxLength)
                .matches(branchPattern, branchPatternMessage),
              bankAccountNumber: Yup.string()
                .nullable()
                .max(nameMaxLength)
                .matches(bankAccountNoPattern, bankAccountNoPatternMessage),
              bankAccountType: Yup.object().nullable(),
            }),
        }),
        nominee2: Yup.object()
          .nullable()
          .shape({
            nomineeCount: Yup.number(),
            sharePercentage: Yup.number()
              .nullable()
              .min(1)
              .max(100)
              .integer()
              .when("nomineeCount", {
                is: 2,
                then: Yup.number().required("Required"),
              }),
            salutation: Yup.object()
              .nullable()
              .when("nomineeCount", {
                is: 2,
                then: Yup.object().nullable().required("Required"),
              }),
            name: Yup.string()
              .nullable()
              .max(fullNameMaxLength)
              .when("nomineeCount", {
                is: 2,
                then: Yup.string().required("Required"),
              })
              .matches(pattern, patternMessage),
            relationship: Yup.object()
              .nullable()
              .when("nomineeCount", {
                is: 2,
                then: Yup.object().nullable().required("Required"),
              }),
            otherRelationshipRequired: Yup.boolean(),
            otherRelationship: Yup.string()
              .nullable()
              .max(nameMaxLength)
              .matches(pattern, patternMessage)
              .when("otherRelationshipRequired", {
                is: true,
                then: Yup.string().required("Required"),
              }),
            addressLine1: Yup.string()
              .nullable()
              .max(AddressMaxLength)
              .when(["nomineeCount", "addressLine2", "addressLine3"], {
                is: (nomineeCount, addressLine2, addressLine3) =>
                  nomineeCount === 2 && !addressLine2 && !addressLine3,
                then: Yup.string()
                  .nullable()
                  .required("Please fill any one of the address line"),
              })
              .matches(addressPattern, patternMessage),
            addressLine2: Yup.string()
              .nullable()
              .max(AddressMaxLength)
              .matches(addressPattern, patternMessage),
            addressLine3: Yup.string()
              .nullable()
              .max(addressLineThreeMaxLength)
              .matches(addressPattern, patternMessage),
            city: Yup.string()
              .nullable()
              .max(CityMaxLength)
              .when("nomineeCount", {
                is: 2,
                then: Yup.string().required("Required"),
              })
              .matches(pattern, patternMessage),
            country: Yup.object()
              .nullable()
              .when("nomineeCount", {
                is: 2,
                then: Yup.object().nullable().required("Required"),
              }),
            state: Yup.object()
              .nullable()
              .when("nomineeCount", {
                is: 2,
                then: Yup.object().nullable().required("Required"),
              }),
            pincode: Yup.string()
              .nullable()
              .max(PincodeMaxLength)
              .when("nomineeCount", {
                is: 2,
                then: Yup.string().required("Required"),
              })
              .matches(pincodePattern, pincodePatternMessage),
            mobileCountry: Yup.object()
              .nullable()
              .when(["isMinor", "nomineeCount"], {
                is: (isMinor, nomineeCount) =>
                  isMinor === "No" && nomineeCount === 2,
                then: Yup.object().required("Required").nullable(),
              }),
            mobileNo: Yup.string()
              .nullable()
              .max(MobileNoMaxLength, mobileMaxLengthMessage)
              .min(MobileNoMinLength, mobileMinLengthMessage)
              .when(["isMinor", "nomineeCount"], {
                is: (isMinor, nomineeCount) =>
                  isMinor === "No" && nomineeCount === 2,
                then: Yup.string().required("Required").nullable(),
              })
              .matches(mobilePattern, mobilePatternMessage),
            emailId: Yup.string()
              .nullable()
              .max(emailMaxLength)
              .email()
              .when("nomineeCount", {
                is: 2,
                then: Yup.string().required("Required"),
              }),
            bankName: Yup.string()
              .nullable()
              .max(nameMaxLength)
              .matches(pattern, patternMessage),
            ifscCode: Yup.string()
              .nullable()
              .max(IfscMaxLength, "Must be equal to 11 characters")
              .min(IfscMinLength, "Must be equal to 11 characters"),

            branchName: Yup.string()
              .nullable()
              .max(nameMaxLength)
              .matches(branchPattern, branchNamepatternMessage),
            bankAccountNumber: Yup.string()
              .nullable()
              .max(nameMaxLength)
              .matches(bankAccountNoPattern, bankAccountNoPatternMessage),
            bankAccountType: Yup.object().nullable(),
            isMinor: Yup.string().when("nomineeCount", {
              is: 2,
              then: Yup.string().required("Required"),
            }),
            minorDOB: Yup.date()
              .nullable()
              .when("isMinor", {
                is: "Yes",
                then: Yup.date()
                  .nullable()
                  .required("Required")
                  .min(minorminDate(), "Must be below 18"),
              })
              .max(
                new Date().toISOString().slice(0, 10),
                "Date cannot be in the future",
              )
              .transform((curr, orig) => (orig === "" ? null : curr)),

            residentialStatus: Yup.string().nullable(),
            guardianDTO: Yup.object()
              .nullable()
              .shape({
                isMinor: Yup.string().nullable(),
                name: Yup.string()
                  .nullable()
                  .max(nameMaxLength)
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.string().nullable().required("Required"),
                  })
                  .matches(pattern, patternMessage),
                addressLine1: Yup.string()
                  .nullable()
                  .max(AddressMaxLength)
                  .when(["isMinor", "addressLine2", "addressLine3"], {
                    is: (isMinor, addressLine2, addressLine3) =>
                      isMinor === "Yes" && !addressLine2 && !addressLine3,
                    then: Yup.string()
                      .nullable()
                      .required("Please fill any one of the address line"),
                  })
                  .matches(addressPattern, patternMessage),
                addressLine2: Yup.string()
                  .nullable()
                  .max(AddressMaxLength)
                  .matches(addressPattern, patternMessage),
                addressLine3: Yup.string()
                  .nullable()
                  .max(addressLineThreeMaxLength)
                  .matches(addressPattern, patternMessage),
                city: Yup.string()
                  .nullable()
                  .max(CityMaxLength)
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.string().nullable().required("Required"),
                  })
                  .matches(pattern, patternMessage),
                country: Yup.object()
                  .nullable()
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.object().required("Required").nullable(),
                  }),
                state: Yup.object()
                  .nullable()
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.object().required("Required").nullable(),
                  }),
                pincode: Yup.string()
                  .nullable()
                  .max(PincodeMaxLength)
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.string().nullable().required("Required"),
                  })
                  .matches(pincodePattern, pincodePatternMessage),
                mobileCountry: Yup.object()
                  .nullable()
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.object().required("Required").nullable(),
                  }),
                mobileNo: Yup.string()
                  .nullable()
                  .max(MobileNoMaxLength, mobileMaxLengthMessage)
                  .min(MobileNoMinLength, mobileMinLengthMessage)
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.string().nullable().required("Required"),
                  })
                  .matches(mobilePattern, mobilePatternMessage),
                emailId: Yup.string()
                  .nullable()
                  .email()
                  .max(emailMaxLength)
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.string().nullable().required("Required"),
                  }),
                relationship: Yup.object()
                  .nullable()
                  .when("isMinor", {
                    is: "Yes",
                    then: Yup.object().required("Required").nullable(),
                  }),
                otherRelationshipRequired: Yup.boolean(),
                otherRelationship: Yup.string()
                  .nullable()
                  .max(nameMaxLength)
                  .matches(pattern, patternMessage)
                  .when("otherRelationshipRequired", {
                    is: true,
                    then: Yup.string().required("Required"),
                  }),
                bankName: Yup.string()
                  .nullable()
                  .max(nameMaxLength)
                  .matches(pattern, patternMessage),
                ifscCode: Yup.string()
                  .nullable()
                  .max(IfscMaxLength, "Must be equal to 11 characters")
                  .min(IfscMinLength, "Must be equal to 11 characters"),

                branchName: Yup.string()
                  .nullable()
                  .max(nameMaxLength)
                  .matches(branchPattern, branchPatternMessage),
                bankAccountNumber: Yup.string()
                  .nullable()
                  .max(nameMaxLength)
                  .matches(bankAccountNoPattern, bankAccountNoPatternMessage),
                bankAccountType: Yup.object().nullable(),
              }),
          }),
      }),
    }),
  },

  {
    widgetShortName: "BANKVF",
    validationSchemaObj: Yup.object({
      bankAccountVerificationDTO: Yup.object().shape({
        bankAccountDetailsDTO: Yup.object().shape({
          bankName: Yup.object().nullable().required("Required"),

          ifscBranch: Yup.object()
            .nullable()
            .when(["ifscCode"], {
              is: (ifscCode) => !ifscCode,
              then: Yup.object().nullable().required("Required"),
            }),
          branch: Yup.string()
            .nullable()
            .max(bankDetailsMaxLength)
            .required("Required")
            .matches(addressPattern, patternMessage),
          name: Yup.string()
            .nullable()
            .max(fullNameMaxLength)
            .required("Required")
            .matches(pattern, patternMessage),
          //active: Yup.string().nullable().required("Required"),
          ifscCode: Yup.string()
            .nullable()
            .max(IfscMaxLength, "Must be equal to 11 characters")
            .min(IfscMinLength, "Must be equal to 11 characters")
            .required("Required"),
          accountNumber: Yup.string()
            .nullable()
            .max(accountDetailsMaxLength)
            .required("Required")
            .matches(bankAccountNoPattern, bankAccountNoPatternMessage),
          accountType: Yup.object().nullable().required("Required"),
        }),
        pennyDropDTO: Yup.object().shape({
          isVerified: Yup.boolean().nullable().required("Required"),
          bankVerificationImage: Yup.string().nullable(),
          bankVerificationFileName: Yup.string()
            .nullable()
            .when("isVerified", {
              is: false,
              then: Yup.string().nullable().required("Required"),
            }),
          bankVerificationFilePath: Yup.string().nullable(),
        }),
      }),
    }),
  },

  {
    widgetShortName: "VIDEOKYC",
    validationSchemaObj: Yup.object({
      videoKycDTO: Yup.object().shape({
        reviewerAction: Yup.string().nullable(),
      }),
    }),
  },
  {
    widgetShortName: "ESIGNTC",
    validationSchemaObj: Yup.object({
      eSignDocumentInfoDTO: Yup.object().shape({
        content: Yup.string().nullable(),
        termsAndConditionsAccepted: Yup.boolean()
          .nullable()
          .required("Please accept the terms & conditions.")
          .oneOf([true], "Please accept the terms & conditions."),
      }),
    }),
  },
];
